<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import { cancelReservation } from '../api/reservation.api'
    import { t } from '../lib/i18n/t';

    export let dataProvider: DataProvider

    let submitted = false
    let error = false
    let processing = false

    const cancel = async () => {
        try {
            error = false
            processing = true
            await cancelReservation({ hash: dataProvider.hash })
            submitted = true
        } catch (e) {
            error = true
        } finally {
            processing = false
        }
    }
</script>

<div class="bno-container bno-container--centered">
    <div class="bno-container__content">
        {#if submitted}
            <h2>{t("cancel.hotovo")}</h2>
            <p>{t("cancel.vaseRezervaceBylaUspesneZrusena")}</p>
        {:else}
            <h2>{t("cancel.zruseniRezervaceNaUrad")}</h2>
            {#if error}
                <div class="bno-alert-light bno-alert-light--error">
                    <span class="bno-icon bno-icon--info"></span>
                    {t("cancel.rezervaciSeNepodariloZrusit")}
                </div>
            {/if}
            <button disabled="{processing}"
                    on:click={() => cancel()}
                    class="bno-button bno-button--primary">
                {#if processing}
                    {t("cancel.pockejteProsim")}...
                {:else}
                    {t("cancel.zrusitRezervaci")}
                {/if}
            </button>
        {/if}
    </div>
</div>
